(function () {
  const ProductForm = {
    bound: new WeakSet(),

    init() {
      document.querySelectorAll('[data-product-form]').forEach((form) => {
        this.setup(form);
      });
      this.initStickyBar();
    },

    bind(form) {
      this.setup(form);
    },

    setup(form) {
      if (this.bound.has(form)) return;
      this.bound.add(form);
      const handle = form.dataset.productHandle;
      const addBtn = form.querySelector('[data-add-to-cart]');
      const variantInput = form.querySelector('[data-variant-id]');
      const buyBtn = form.querySelector('[data-buy-now]');

      this.loadProductData(handle).then((product) => {
        form._product = product;
        this.updateState(form);
      });

      form.querySelectorAll('[data-variant-input]').forEach((input) => {
        input.addEventListener('change', () => {
          this.updateState(form);
          const event = new CustomEvent('variant:change', { detail: { form } });
          document.dispatchEvent(event);
        });
      });

      form.querySelectorAll('[data-variant-select]').forEach((select) => {
        select.addEventListener('change', () => {
          this.updateState(form);
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', (e) => {
          e.preventDefault();
          const id = variantInput ? parseInt(variantInput.value, 10) : null;
          if (!id || !window.ShopifyCart) return;
          const qtyInput = form.querySelector('[data-qty-input]');
          const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
          window.ShopifyCart.add(id, qty, addBtn);
        });
      }

      if (buyBtn) {
        buyBtn.addEventListener('click', (e) => {
          const id = variantInput ? parseInt(variantInput.value, 10) : null;
          if (!id) {
            e.preventDefault();
            return;
          }
          if (!window.ShopifyCart) return;
          const qtyInput = form.querySelector('[data-qty-input]');
          const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
          e.preventDefault();
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [{ id, quantity: qty }] }),
          }).then((res) => {
            if (res.ok) {
              window.location.href = '/checkout';
            } else {
              Branzos.showToast(window.ShopifyTheme.i18n.cartError, '😵');
            }
          }).catch(() => {
            Branzos.showToast(window.ShopifyTheme.i18n.cartError, '😵');
          });
        });
      }

      this.setupGallery(form);
    },

    loadProductData(handle) {
      if (window.BranzosProductCache && window.BranzosProductCache[handle]) {
        return Promise.resolve(window.BranzosProductCache[handle]);
      }
      return fetch(`/products/${handle}.js`)
        .then((res) => res.json())
        .then((data) => {
          if (!window.BranzosProductCache) window.BranzosProductCache = {};
          window.BranzosProductCache[handle] = data;
          return data;
        });
    },

    getSelectedOptions(form) {
      const options = [];
      form.querySelectorAll('[data-option-name]').forEach((el) => {
        const name = el.dataset.optionName;
        const checked = el.querySelector('input:checked');
        if (checked) {
          options.push({ name, value: checked.value });
        }
      });
      form.querySelectorAll('[data-variant-select]').forEach((select) => {
        options.push({ name: select.dataset.optionName, value: select.value });
      });
      return options;
    },

    findVariant(product, options) {
      if (!options.length) return product.variants[0];
      return product.variants.find((v) =>
        options.every((opt) => {
          const idx = product.options.findIndex((o) => o.name === opt.name);
          return idx >= 0 && v.options[idx] === opt.value;
        })
      ) || null;
    },

    updateState(form) {
      const product = form._product;
      if (!product) return;
      const options = this.getSelectedOptions(form);
      const variant = this.findVariant(product, options);
      const variantInput = form.querySelector('[data-variant-id]');
      const addBtn = form.querySelector('[data-add-to-cart]');
      const buyBtn = form.querySelector('[data-buy-now]');
      const price = form.querySelector('[data-price]');
      const compare = form.querySelector('[data-compare-price]');
      const priceWrap = form.querySelector('[data-price-wrap]');
      const nameEl = form.querySelector('[data-sticky-name]');
      const priceEl = form.querySelector('[data-sticky-price]');
      const stockMsg = form.querySelector('[data-stock-message]');

      form.querySelectorAll('.variant-picker__group').forEach((group) => {
        const checked = group.querySelector('input:checked');
        const display = group.querySelector('[data-option-value-display]');
        if (checked && display) display.textContent = checked.value;
      });

      this.updateOptionAvailability(product, options, variant, form);

      if (variant) {
        if (variantInput) variantInput.value = variant.id;
        if (price) price.textContent = window.ShopifyTheme.money(variant.price);
        if (compare && variant.compare_at_price) {
          compare.textContent = window.ShopifyTheme.money(variant.compare_at_price);
          compare.style.display = '';
          if (priceWrap) priceWrap.classList.add('price--sale');
        } else if (compare) {
          compare.style.display = 'none';
          if (priceWrap) priceWrap.classList.remove('price--sale');
        }
        if (stockMsg) {
          if (variant.available) {
            stockMsg.style.display = 'none';
          } else {
            stockMsg.style.display = '';
            stockMsg.textContent = window.ShopifyTheme.i18n.soldOut;
          }
        }
        if (nameEl) nameEl.textContent = product.title;
        if (priceEl) priceEl.textContent = window.ShopifyTheme.money(variant.price);
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.querySelector('[data-add-label]').textContent = variant.available
            ? window.ShopifyTheme.i18n.addToCart
            : window.ShopifyTheme.i18n.soldOut;
        }
        if (buyBtn) {
          buyBtn.disabled = !variant.available;
        }
        this.updateGalleryImage(form, variant);
        this.updateSticky(form, variant);
      }
    },

    updateOptionAvailability(product, options, selectedVariant, form) {
      if (!form) return;
      const inputs = form.querySelectorAll('[data-variant-input]');
      inputs.forEach((input) => {
        const groupName = input.dataset.optionName;
        const optionIdx = product.options.findIndex((o) => o.name === groupName);
        const currentOptions = options.filter((o) => o.name !== groupName);
        const candidates = product.variants.filter((v) =>
          currentOptions.every((o) => {
            const idx = product.options.findIndex((x) => x.name === o.name);
            return idx >= 0 && v.options[idx] === o.value;
          })
        );
        const variant = candidates.find((v) => v.options[optionIdx] === input.value);
        const available = variant ? variant.available : false;
        input.disabled = !available;
        input.closest('label').classList.toggle('is-unavailable', !available);
      });
    },

    setupGallery(form) {
      // Gallery nav is handled by the inline script in main-product.liquid
    },

    updateGalleryImage(form, variant) {
      if (!variant.featured_image) return;
      // The inline script in main-product.liquid exposes BranzosGalleryGoTo(imageId)
      var imageId = variant.image_id || (variant.featured_image && variant.featured_image.id);
      if (imageId && window.BranzosGalleryGoTo) {
        window.BranzosGalleryGoTo(imageId);
      }
    },

    updateSticky(form, variant) {
      const bar = document.querySelector('[data-sticky-addtocart]');
      if (!bar) return;
      if (!variant.available) {
        bar.classList.remove('is-visible');
        return;
      }
      const img = bar.querySelector('[data-sticky-img]');
      if (img && variant.featured_image) {
        const url = typeof variant.featured_image === 'string'
          ? variant.featured_image
          : variant.featured_image.url;
        img.src = url.split('?')[0] + '?width=200';
      }
      this.lastVisibleVariant = variant;
    },

    initStickyBar() {
      const bar = document.querySelector('[data-sticky-addtocart]');
      if (!bar) return;
      const add = bar.querySelector('[data-sticky-add]');
      const main = document.querySelector('[data-product-form]');

      const onScroll = () => {
        if (!main) return;
        const mainRect = main.getBoundingClientRect();
        const addBtn = main.querySelector('[data-add-to-cart]');
        const visible = addBtn && addBtn.offsetParent !== null && window.scrollY > 300 && mainRect.bottom < 0;
        bar.classList.toggle('is-visible', visible);
      };
      window.addEventListener('scroll', Branzos.debounce(onScroll, 100), { passive: true });
      onScroll();

      if (add) {
        add.addEventListener('click', (e) => {
          e.preventDefault();
          const form = main;
          if (!form || !form._product) return;
          const variantInput = form.querySelector('[data-variant-id]');
          const id = variantInput ? parseInt(variantInput.value, 10) : null;
          if (!id || !window.ShopifyCart) return;
          window.ShopifyCart.add(id, 1, add);
        });
      }
    },
  };

  window.ShopifyProductForm = ProductForm;
  Branzos.onLoad(() => ProductForm.init());
})();
